import {createI18nScope} from 'common/i18n/scope';

const __i18nScope = createI18nScope(`common.copilot`, {
  'copilot.close-chat': `Close chat`,
  'copilot.create-board.notification-open-failed': `Could not open the Mixpanel Agent board.`,
  'copilot.create-board.notification-still-preparing': `The Mixpanel Agent board is still being prepared. Try again in a moment.`,
  'copilot.create-board.ready': `Your Mixpanel Agent board is ready`,
  'copilot.create-board.view-board': `View board`,
  'copilot.create-report.notification-open-failed': `Could not open the Mixpanel Agent report.`,
  'copilot.create-report.ready': `Your Mixpanel Agent report is ready`,
  'copilot.create-report.view-report': `View report`,
  'copilot.delete.description': `Are you sure you want to delete this chat?`,
  'copilot.delete.title': `Delete chat`,
  'copilot.expand-chat': `Open in full view`,
  'copilot.history.delete-error': `Failed to delete conversation.`,
  'copilot.history.title': `Chat History`,
  'copilot.history.untitled': `Untitled`,
  'copilot.limits.ai-credits-exhausted': `The AI credit limit has been reached. Contact your organization admin.`,
  'copilot.limits.conversation-size-reached': `This chat has reached its size limit. Please start a new chat.`,
  'copilot.limits.project-tokens-reached': `This project has reached its monthly Mixpanel Agent token limit.`,
  'copilot.limits.project-turns-free-reached': `This project has reached the monthly Mixpanel Agent message limit for the free plan. Upgrade your plan to raise this limit.`,
  'copilot.limits.project-turns-reached': `This project has reached its monthly Mixpanel Agent message limit.`,
  'copilot.limits.user-tokens-reached': `You've reached your monthly Mixpanel Agent token limit.`,
  'copilot.limits.user-turns-hourly-free-reached': `You've reached the hourly Mixpanel Agent message limit for the free plan. Upgrade your plan to raise this limit.`,
  'copilot.limits.user-turns-reached': `You've reached your monthly Mixpanel Agent message limit.`,
  'copilot.menu.new-chat': `New Chat`,
  'copilot.model-provider-degraded': `Our AI model provider is experiencing degraded service.`,
  'copilot.new-chat': `New chat`,
  'copilot.onboarding.chat-title': `Onboarding {{date}}`,
  'copilot.rename.save-error': `Failed to rename chat.`,
  'copilot.response-error': `There was an error responding to your message.`,
  'copilot.shared.view-only': `View only`,
  'copilot.warning': `Mixpanel Agent is AI. Please verify responses.`,
});

__i18nScope.registerTranslationLoaders({"es": () => import("virtual:i18n-scope/es/common.copilot"), "fr": () => import("virtual:i18n-scope/fr/common.copilot"), "id": () => import("virtual:i18n-scope/id/common.copilot"), "ja": () => import("virtual:i18n-scope/ja/common.copilot"), "ko": () => import("virtual:i18n-scope/ko/common.copilot"), "pt": () => import("virtual:i18n-scope/pt/common.copilot"), "zh-CN": () => import("virtual:i18n-scope/zh-CN/common.copilot"), "zh-TW": () => import("virtual:i18n-scope/zh-TW/common.copilot")});
export default __i18nScope;
